export const environment = {
  production: true,
  apiUrl: 'https://api.windsor-institute.com/api',
  //apiUrl: 'https://api.controlup.com.ar/api',
  //apiUrl: 'http://localhost:11784/api',
};
